<div class="login-container" ng-controller="ForgotPasswordCtrl">
  <div class="bubbles">
    <div class="bubble"></div>
    <div class="bubble"></div>
    <div class="bubble"></div>
    <div class="bubble"></div>
  </div>

  <div class="left-section">
    <div class="main-logo">
      <img src="assets/images/cliQTest Logo Full.png" alt="CliQTest Logo">
    </div>
    <div class="subtitle">
      Reset your<br>
      password and<br>
      get back to<br>
      your automation<br>
      journey
    </div>
  </div>

  <div class="login-wrapper">
    <div class="login-box">
      <div class="login-header">
        <div class="brand-info">
          <h1 class="brand-name">Reset Password</h1>
          <!-- <p class="brand-tagline">Making usability better</p> -->
          @if (!otpSent) {
            <p class="brand-tagline">Enter your email to receive OTP</p>
          }
          @if (otpSent) {
            <p class="brand-tagline">Enter OTP and new password</p>
          }
        </div>
      </div>
      <div class="form-container forgot-password-form">
        <!-- Step 1: Enter Email -->
        @if (!otpSent) {
          <div>
            <label for="email">Enter your valid email</label>
            <div class="form-group">
              <div class="input-wrapper">
                <i class="fa fa-envelope input-icon"></i>
                <input
                  class="form-control input-box"
                  name="username"
                  [(ngModel)]="userEmail"
                  type="email"
                  placeholder="Email"
                  autocorrect="off"
                  autocapitalize="off"
                  spellcheck="false"
                  />
              </div>
            </div>
            <button class="btn btn-primary login-btn Sendotp" (click)="sendOtp()">
              Send OTP <i class="fa fa-paper-plane"></i>
            </button>
          </div>
        }

        <!-- Step 2: Enter OTP and New Password -->
        @if (otpSent) {
          <div>
            <div class="form-group">
              <label for="otp">Enter OTP</label>
              <div class="input-wrapper">
                <i class="fa fa-key input-icon"></i>
                <input
                  class="form-control"
                  id="otp"
                  [(ngModel)]="otp"
                  type="text"
                  placeholder="OTP"
                  required
                  />
              </div>
            </div>
            <div class="form-group">
              <label for="newPassword">New Password</label>
              <div class="input-wrapper">
                <i class="fa fa-lock input-icon"></i>
                <input
                  class="form-control"
                  id="newPassword"
                  [(ngModel)]="newPassword"
                  type="password"
                  placeholder="New Password"
                  required
                  />
              </div>
            </div>
            <div class="form-group">
              <label for="confirmPassword">Confirm Password</label>
              <div class="input-wrapper">
                <i class="fa fa-check-circle input-icon"></i>
                <input
                  class="form-control"
                  id="confirmPassword"
                  [(ngModel)]="confirmPassword"
                  type="password"
                  placeholder="Confirm Password"
                  required
                  />
              </div>
            </div>
            <button class="btn btn-primary login-btn" (click)="resetPassword()">
              Reset Password <i class="fa fa-arrow-right"></i>
            </button>
          </div>
        }

        <!-- Back Button to Cancel Forgot Password -->
        <div class="additional-options">
          <button class="btn support-btn Cancelbtn" (click)="backtoLogin()">
            <i class="fa fa-arrow-left"></i> Back to Login
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #alerttemplate let-modal>
  <div class="modal-body text-center">
    <p class="alert-message" style="overflow-wrap: break-word;">{{msg}}</p>
    <div class="alert-actions">
      <button type="button" class="btn btn-success" (click)="Ok()">OK</button>&nbsp;
    </div>
  </div>
</ng-template>